import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Ancienne adresse /cofinancement/:dealId (liens envoyés par mail) : renvoie vers la simulation Skipcar+. */
const RedirectionAncienneSimulation: React.FC = () => {
  const { dealId } = useParams<{ dealId: string }>();
  return <Navigate to={`/skipcar-plus/${dealId}/simulation`} replace />;
};

export default RedirectionAncienneSimulation;
